import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { formatThousands } from "@/utils/index.js";
import RelatedContract from "./RelatedContract.vue";
import util from "@/libs/util";
import SourceTag from "@/views/quarter/components/SourceTag.vue";
export default {
  name: "PaymentConnect",
  components: {
    SourceTag: SourceTag,
    RelatedContract: RelatedContract
  },
  data: function data() {
    return {
      visible: false,
      loading: false,
      form: {
        receiptAmount: "",
        payer: "",
        payeeCompany: "",
        orderAmount: "",
        depositAmount: "",
        transactionNo: "",
        //交易流水号
        contractCode: "",
        //合同编号
        companyId: "",
        //公司
        slip: "",
        //回单
        adminId: util.cookies.get("uuid") || "" //操作人
      },
      companyLoading: false,
      companyList: [],
      rules: {
        contractCode: [{
          required: true,
          message: '请选择合同',
          trigger: 'change'
        }],
        companyId: [{
          required: true,
          message: '请选择公司',
          trigger: 'change'
        }],
        slip: [{
          required: true,
          message: '请上传回单',
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    isAli: function isAli() {
      return this.form.dataSource === "ALIPAY";
    }
  },
  methods: {
    formatThousands: formatThousands,
    show: function show(row) {
      this.form = _objectSpread(_objectSpread({}, this.form), JSON.parse(JSON.stringify(row))) || {};
      if (this.form.status === "1") {
        var _this$form, _this$form2;
        this.form.contractCode = this.form.associateContract;
        this.form.companyId = (_this$form = this.form) !== null && _this$form !== void 0 && _this$form.associateCompany ? Number((_this$form2 = this.form) === null || _this$form2 === void 0 ? void 0 : _this$form2.associateCompany) : '';
        this.form.slip = this.form.returnSlip;
        this.remoteMethod(this.form.companyName);
      }
      this.form.slip = this.form.returnSlip;
      this.rules.slip[0].required = this.form.dataSource === "ALIPAY";
      this.visible = true;
    },
    save: function save() {
      var _this = this;
      this.$refs["ruleForm"].validate(function (valid) {
        if (valid) {
          _this.loading = true;
          var params = {
            contractCode: _this.form.contractCode,
            companyId: _this.form.companyId,
            transactionNo: _this.form.receiptWaterNbr,
            slip: _this.form.slip,
            adminId: _this.form.adminId
          };
          _this.$api.relatedContracts(params).then(function (res) {
            if (res.code === 200) {
              _this.$message.success("关联成功");
              _this.visible = false;
              _this.$emit('confirm');
              // 操作上报
              _this.$operationLog.push({
                code: _this.form.status === '1' ? 'edit' : 'connect',
                operationType: 'payment',
                // userId: this.form.companyId, 公司 id
                detailBatchNo: _this.form.receiptWaterNbr
              });
            }
          }).finally(function () {
            _this.loading = false;
          });
        }
      });
    },
    remoteMethod: function remoteMethod(query) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (query !== "") {
                _this2.getCompanyList(query);
              }
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getCompanyList: function getCompanyList(query) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _res$data;
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this3.companyLoading = true;
              _context2.n = 1;
              return _this3.$api.findAllBqCompanyinfo({
                companyName: query,
                pageNum: 1,
                pageSize: 20
              });
            case 1:
              res = _context2.v;
              _this3.companyLoading = false;
              _this3.companyList = ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.content) || [];
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    relate: function relate() {
      this.$refs.relatedContract.show(this.form);
    },
    //选中合同返回值
    selectContract: function selectContract(row) {
      this.form = _objectSpread(_objectSpread({}, this.form), {}, {
        contractCode: row.contractCode,
        orderAmount: row.orderAmount,
        depositAmount: row.depositAmount,
        totalAmount: row.totalAmount
      });
    },
    close: function close() {
      this.form = {
        receiptAmount: "",
        payer: "",
        payeeCompany: "",
        orderAmount: "",
        depositAmount: "",
        transactionNo: "",
        //交易流水号
        contractCode: "",
        //合同编号
        companyId: "",
        //公司
        slip: "",
        //回单
        adminId: util.cookies.get("uuid") || "" //操作人
      };
      this.$refs["ruleForm"].resetFields();
      this.companyLoading = false;
      this.companyList = [];
    },
    previewPdf: function previewPdf(url) {
      window.open(url);
    }
  }
};